import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { Observable } from 'rxjs/Observable';
import { CampaignService } from '../../../../../services/campaign/campaign.service';
import { CouponService } from '../../../../../services/campaign/coupon.service';
import { Campaign } from '../../campaign';


@Component({
  selector: 'campaign-coupons',
  templateUrl: 'campaign-coupons.html',
  providers: [CouponService],
  styles: ['.product-table td { overflow-x: auto !important }']
})
export class CampaignCouponsComponent {

  @Input() campaign: Campaign;

  @Input() returnedSavedCategories: any[];
  @Input() returnedSavedProductCouponsF: any[];
  @Input() returnedSavedProductCouponsNF: any[];

  @Output() savedSelectedCategories: EventEmitter<any[]> = new EventEmitter();
  @Output() savedProductCouponsF: EventEmitter<any[]> = new EventEmitter();
  @Output() savedProductCouponsNF: EventEmitter<any[]> = new EventEmitter();

  private panel: number;
  private categories: Array<any> = [];
  private products: Array<any> = [];
  public showCouponsPreview = false;
  public coupons: Array<any> = [];
  // categorie selezionate per Coupon Categorie
  selectedCategories: any[] = [];

  private productCouponsF: any[] = [];
  private productCouponsNF: any[] = [];
  private tradeDriveActivationCounter = 0

  private couponData = [
    {
       codice_tipo: 1,
       coupon: {}
    },
    {
       codice_tipo: 2,
       categorie_selezionate: []
    },
    {
       codice_tipo: 3,
       lista_coupon: []
    },
    {
       codice_tipo: 4,
       lista_coupon: []
    }
  ];

  suggestedCategoriesData: any[];
  translations: any;

  constructor(
    private campaignService: CampaignService,
    private couponService: CouponService,
    private confirmationService: ConfirmationService,
    private translate: TranslateService) {
  }


  ngOnInit()
  {
    this.translate.get([
      'campaign.addProductMsg'
    ]).subscribe( res => {
      this.translations = res;
    });

    this.campaign.coupons = this.campaign.coupons || [];

    if(this.campaign.coupons.length > 0) {
      return;
    }

    Observable.zip(
      this.campaignService.getCouponTypes(),
      this.campaignService.getCouponTypeSuggestions(this.campaign.targetId)
    ).subscribe(([couponTypes, couponSuggestion]) => {

      couponTypes = couponTypes.filter(coupon => couponSuggestion.indexOf(coupon.codice_tipo) !== -1);

      const couponIcons = [
        'fa fa-shopping-cart',
        'fa fa-bookmark',
        'fa fa-barcode'
      ];

      this.campaign.coupons = couponTypes.map((coupon, i) => {
        const type_code = parseInt(coupon.codice_tipo);

        coupon = {
          type_code: type_code,
          name: coupon.descrizione_tipo,
          active: false,
          icon: couponIcons[i],
          offerta: 0,
          offerta_min: 0,
          offerta_max: 0,
          passo_offerta: 1,
          offerta_slider: [],
          stretch: 0,
          stretch_min: 0,
          stretch_max: 0,
          passo_stretch: 1,
          stretch_slider: [],
          generatedCoupons: []
        };

        return coupon;
      });

      this.panel = 1;
    },
    err => console.error(err),
    () => this.campaignService.getActiveCoupons(this.campaign.name).subscribe(
      res => {
        res.filter(
          r => r.flag_tipo_attivo
        )
        .map(
          activeCoupon => this.campaign.coupons
          .filter(
            coupon => parseFloat(activeCoupon.codice_tipo.toFixed(1)) === coupon.type_code
          )
          .map(
            couponToActivate => {
              couponToActivate.active = true;
              if (couponToActivate.type_code === 1 && couponToActivate.active) {
                this.tradeDriveActivationCounter = 1;
                this.couponService.getTradeDriverSuggestion(this.campaign.targetId, this.campaign.name, couponToActivate)
                .then(res => couponToActivate = res);
              }
              if (couponToActivate.type_code === 2 && couponToActivate.active) {
                this.getCouponCategories(2)
                .then( () => {
                  this.couponService.getCategoryCouponSuggestion(this.campaign.targetId, this.campaign.name, couponToActivate)
                  .then(res => {
                    couponToActivate = res.coupon;
                    if (res.categories && res.categories.length > 0) {
                      this.suggestedCategoriesData = [...res.categories];
                      this.categories.forEach(cat => {
                        this.suggestedCategoriesData.forEach(sug => {
                          if (cat.codice_categoria === sug.codice_categoria) {
                            Object.assign(cat, {
                              offerta: sug.offerta_utente,
                              stretch: sug.stretch_utente,
                              soglia: [sug.soglia_min_utente, sug.soglia_max_utente],
                              soglia_min: couponToActivate.soglia_min,
                              soglia_max: couponToActivate.soglia_max,
                              step: sug.ampiezza_step_utente
                            });
                          }
                        })
                      });
                    }
                  })
                })
              } else if (
                couponToActivate.type_code === 3 && couponToActivate.active && (!this.returnedSavedProductCouponsF || this.returnedSavedProductCouponsF.length === 0)
                || couponToActivate.type_code === 4 && couponToActivate.active && (!this.returnedSavedProductCouponsNF || this.returnedSavedProductCouponsNF.length === 0)) {
                this.getProductCoupons(couponToActivate);
              }
            }
          )
        );
      }
    )
    );
  }

  ngOnChanges(changes) {
    if (changes.returnedSavedCategories.currentValue.length > 1 && changes.returnedSavedCategories.currentValue[0]) {
      this.getCouponCategories(2, 'ngOnChanges', changes.returnedSavedCategories.currentValue[0]);
    }
    if (changes.returnedSavedProductCouponsF.currentValue.length > 0) {
      this.productCouponsF = changes.returnedSavedProductCouponsF.currentValue;
    }
    if (changes.returnedSavedProductCouponsNF.currentValue.length > 0) {
      this.productCouponsNF = changes.returnedSavedProductCouponsNF.currentValue;
    }
  }

  getCouponByType(type_code)
  {
    let coupon_index = -1;

    this.campaign.coupons.forEach((coupon, i) => {
      if(coupon.type_code == type_code) {
        coupon_index = i;
      }
    });

    return this.campaign.coupons[coupon_index];
  }

  setPanel(panel)
  {
    this.panel = parseInt(panel);
  }

  toggleActive(coupon, event)
  {
    const active = event.checked;
    this.resetCoupons(coupon.type_code);
    if (active) {
      if (coupon.type_code === 1 && this.tradeDriveActivationCounter === 0) {
        this.tradeDriveActivationCounter = 1;
        this.couponService.getTradeDriverSuggestion(this.campaign.targetId, this.campaign.name, coupon)
        .then(res => coupon = res);
      } else if (coupon.type_code === 2 && (!this.returnedSavedCategories || this.returnedSavedCategories.length === 0)) {
        this.getCouponCategories(2);
        this.couponService.getCategoryCouponSuggestion(this.campaign.targetId, this.campaign.name, coupon)
        .then(res => {
          coupon = res.coupon;
          if (res.categories && res.categories.length > 0) {
            this.suggestedCategoriesData = [...res.categories];
          }
        })
      } else if (
        coupon.type_code === 3 && (!this.returnedSavedProductCouponsF || this.returnedSavedProductCouponsF.length === 0)
        || coupon.type_code === 4 && (!this.returnedSavedProductCouponsNF || this.returnedSavedProductCouponsNF.length === 0)) {
        this.getProductCoupons(coupon);
      }
    } else {
      this.campaignService.disattivaCoupon(coupon.type_code, this.campaign.name).subscribe();
    }
  }

  getCouponCategories(type_code, origin = '', data = []) {
    return new Promise((resolve2, reject) => {
      let coupon = this.getCouponByType(type_code);
      this.campaignService.getCouponCategoryTypes(this.campaign.name).subscribe(
        res => {
          this.selectedCategories = res;
          if (origin === 'ngOnChanges') {
            this.selectedCategories = [];
            data.forEach(rsc => {
              if (rsc.visible) {
                this.selectedCategories.push(rsc.codice_categoria.toString());
              }
            });
            this.categories = res;
            resolve2();
          } else {
            this.campaignService.getCouponCategoryTypeSuggestions(this.campaign.name).subscribe(
              suggestions => {
                if (suggestions && suggestions.length > 0) {
                  coupon.categories = [];
                  suggestions.map(suggestion =>
                    coupon.categories.push(suggestion.toString())
                  );
                }
                this.categories = res;
                resolve2();
              },
            );
          }
        }
      );
    })
  }

  getProductCoupons(coupon) {
    this.couponService.getProductCouponSuggestions(this.campaign.goalId, this.campaign.name, coupon.type_code)
    .then(res =>{
      if (res.length > 0 && (!this.returnedSavedProductCouponsF || this.returnedSavedProductCouponsF.length === 0)) {
        res.forEach(r => {
          let productCoupon: any = {
            offerta_min: r.offerta_min,
            offerta_max: r.offerta_max,
            offerta_slider: this.couponService.sliderSteps(r.offerta_min, r.offerta_max, 5),
            offerta: r.offerta_utente,
            selectedProducts: r.lista_prodotti ? [...r.lista_prodotti.split(',')] : null,
            selectedCategoriesLevel: r.livello_merceologico,
            selectedCategoriesCodes: r.lista_codici_livello ? [...r.lista_codici_livello.split(',')] : null
          }
          if (r.lista_codici_livello) {
            this.applyCouponProductsFilter(r)  // se ci sono categorie selezionate, richiamo la relativa lista prodotti
            .then(couponWithProducts => {
              Object.assign(productCoupon, {
                products: r.products,
                showProductsTable: true
              });
            })
            .then(() => {
              if (coupon.type_code === 3) {
                if (!this.productCouponsF) {
                  this.productCouponsF = [];
                }
                this.productCouponsF.push(productCoupon);
              } else {
                if (!this.productCouponsNF) {
                  this.productCouponsNF = [];
                }
                this.productCouponsNF.push(productCoupon);
              }
            })
          } else {
            Object.assign(productCoupon, {
              products: [],
              showProductsTable: false
            });
            if (coupon.type_code === 3) {
              if (!this.productCouponsF) {
                this.productCouponsF = [];
              }
              this.productCouponsF.push(productCoupon);
            } else {
              if (!this.productCouponsNF) {
                this.productCouponsNF = [];
              }
              this.productCouponsNF.push(productCoupon);
            }
          }
        })
      }
    });
  }

  couponPreviewEnabled()
  {
    return this.campaign.segments.length == 0 || this.campaign.stores.length == 0;
  }

  couponPreviewParams(type_code)
  {
    let coupon = this.getCouponByType(type_code);
    coupon.categories = Array.from(new Set(coupon.categories)); // evita che le categorie vengano duplicate passando da uno step all'altro

    let params = {
      campaign_name: this.campaign.name,
      type_code: type_code,
      product_list: []
    };
    let cPDiscountList: number[] = [];
    let cProductList: number[] = [];

    switch(type_code)
    {
      case 1:
        Object.assign(params, {
          discount: [coupon.offerta],
          stretch: [coupon.stretch],
          step_size: [coupon.ampiezza_step],
          min_threshold: [coupon.soglia[0]],
          max_threshold: [coupon.soglia[1]]
        });
        break;

      case 2:
        let discountList: number[] = [];
        let stretchList: number[] = [];
        let minThresholdList: number[] = [];
        let maxThresholdList: number[] = [];
        let stepSizeList: number[] = [];

        coupon.categories.map(cc => {
          this.categories.forEach(cat => {
            if (cat.codice_categoria == cc) {
              discountList.push(cat.offerta);
              stretchList.push(cat.stretch);
              minThresholdList.push(cat.soglia[0]);
              maxThresholdList.push(cat.soglia[1]);
              stepSizeList.push(cat.step)
            }
          })
        });

        Object.assign(params, {
          cat_prd_items: coupon.categories.map(v => +v),
          discount: discountList,
          stretch: stretchList,
          min_threshold: minThresholdList,
          max_threshold: maxThresholdList,
          step_size: stepSizeList
        })

        break;

        case 3:
          this.productCouponsF.forEach(pc => {
            cPDiscountList.push(pc.offerta);
            if (pc.selectedProducts && pc.selectedProducts.length > 0) {
              cProductList.push(pc.selectedProducts.join());
            }
          });

          Object.assign(params, {
            discount: cPDiscountList,
            product_list: cProductList
          });
          break;

        case 4:
          this.productCouponsNF.forEach(pc => {
            cPDiscountList.push(pc.offerta);
            if (pc.selectedProducts && pc.selectedProducts.length > 0) {
              cProductList.push(pc.selectedProducts.join());
            }
          });

          Object.assign(params, {
            discount: cPDiscountList,
            product_list: cProductList
          });
          break;
    }

    return params;
  }

  resetCoupons(type_code)
  {
    let coupon = this.getCouponByType(type_code);
    this.coupons = [];
    coupon.generatedCoupons = [];

    if(typeof coupon.soglia !== 'undefined') {
      coupon.soglia = [coupon.soglia[0], coupon.soglia[1]];
    }

    if (type_code === 2) {
      this.selectedCategories = coupon.categories;
    }

  }

  couponPreview(type_code)
  {
    let coupon = this.getCouponByType(type_code);
    let params = this.couponPreviewParams(type_code);
    this.resetCoupons(type_code);

    if ((coupon.type_code == 3 || coupon.type_code == 4) && params.product_list.length == 0 ) {
      this.confirmationService.confirm({
        message: this.translations['campaign.addProductMsg'],
        accept: () => false,
        acceptLabel: "Ok",
        rejectVisible: false
      });
    } else {
      Observable.concat(
        this.campaignService.loadCouponPreview(params, type_code),
        this.campaignService.getCouponPreview(this.campaign.name, type_code)
      ).last().subscribe(res => {
        this.coupons = this.filterCoupons(res);
        coupon.generatedCoupons = this.coupons;
        this.showCouponsPreview = true;
      });
    }
  }

  saveCampaign(campaignCoupons) {
    return new Promise((resolve, reject) => {
      campaignCoupons.map(coupon => {
        if (coupon.active && coupon.type_code === 1) {
          this.couponData[0]['coupon'] = {
            stretch_utente: coupon.stretch,
            soglia_min_utente: coupon.soglia[0],
            soglia_max_utente: coupon.soglia[1],
            ampiezza_step_utente: coupon.ampiezza_step,
            offerta_utente: coupon.offerta
          }
        }

        if (coupon.active && coupon.type_code === 2) {
          let categorieSelezionate = this.categories.filter(cat => cat.visible);
          categorieSelezionate.forEach(selectedCat => {
            this.couponData[1]['categorie_selezionate'].push({
              stretch_utente: selectedCat.stretch,
              soglia_min_utente: selectedCat.soglia[0],
              soglia_max_utente: selectedCat.soglia[1],
              ampiezza_step_utente: selectedCat.step,
              offerta_utente: selectedCat.offerta,
              codice_categoria: selectedCat.codice_categoria
            })
          })
        }

        if (coupon.active && coupon.type_code === 3) {
          if (this.productCouponsF && this.productCouponsF.length > 0) {
            this.productCouponsF.forEach(productCoupon => {
              if (!productCoupon.selectedCategoriesLevel
                || !productCoupon.selectedCategoriesCodes
                || productCoupon.selectedCategoriesCodes.length === 0
                || !productCoupon.selectedProducts
                || productCoupon.selectedProducts.length === 0) {
                this.confirmationService.confirm({
                  message: this.translations['campaign.addProductMsg'],
                  accept: () => false,
                  acceptLabel: "Ok",
                  rejectVisible: false
                });
                reject()
              }
              this.couponData[2]['lista_coupon'].push({
                offerta_utente: productCoupon.offerta,
                livello_merceologico: productCoupon.selectedCategoriesLevel,
                lista_codici_livello: productCoupon.selectedCategoriesCodes.toString(),
                lista_prodotti: productCoupon.selectedProducts.toString(),
              })
            })
          }
        }

        if (coupon.active && coupon.type_code === 4) {
          if (this.productCouponsNF && this.productCouponsNF.length > 0) {
            this.productCouponsNF.forEach(productCoupon => {
              if (!productCoupon.selectedCategoriesLevel
                || !productCoupon.selectedCategoriesCodes
                || productCoupon.selectedCategoriesCodes.length === 0
                || !productCoupon.selectedProducts
                || productCoupon.selectedProducts.length === 0) {
                this.confirmationService.confirm({
                  message: this.translations['campaign.addProductMsg'],
                  accept: () => false,
                  acceptLabel: "Ok",
                  rejectVisible: false
                });
                reject();
              }
              this.couponData[3]['lista_coupon'].push({
                offerta_utente: productCoupon.offerta,
                livello_merceologico: productCoupon.selectedCategoriesLevel,
                lista_codici_livello: productCoupon.selectedCategoriesCodes.toString(),
                lista_prodotti: productCoupon.selectedProducts.toString(),
              })
            })
          }
        }
      })
      resolve();
    })

  }

  saveCampaignAndExit() {
    return new Promise((resolve2, reject) => {
      this.saveCampaign(this.campaign.coupons)
      .then(() => this.campaignService.saveCampaign(this.campaign.name, this.couponData).subscribe())
      .then(() => resolve2())
      .catch(() => reject())
    })
  }

  checkAllCoupons(fn?) {
    this.saveCampaign(this.campaign.coupons)
    .then(() => this.campaignService.saveCampaign(this.campaign.name, this.couponData).subscribe())
    .catch(err => console.error(err));

    let counter = 0;

    for (let coupon of this.campaign.coupons) {
      if (coupon.active) {
        counter++;
      }
    }

    for (let coupon of this.campaign.coupons) {
      if (!coupon.active) {
        continue;
      }
      let params = this.couponPreviewParams(coupon.type_code);
      if ((coupon.type_code == 3 || coupon.type_code == 4) && params.product_list.length == 0 ) {
        this.confirmationService.confirm({
          message: this.translations['campaign.addProductMsg'],
          accept: () => false,
          acceptLabel: 'Ok',
          rejectVisible: false
        });
      } else {
        Observable.concat(
          this.campaignService.loadCouponPreview(params, coupon.type_code),
          this.campaignService.getCouponPreview(this.campaign.name, coupon.type_code)
        )
        .last()
        .subscribe(
          res => {
            coupon.generatedCoupons = this.filterCoupons(res);
            counter--;
            if (fn && counter === 0) {
              fn();
            }
          }
        )
      }
    }
  }

  filterCoupons(coupons)
  {
    return coupons.map(coupon => {
      if(coupon.descrizione_metodo.includes('%')) {
        coupon.num_offerta += '%';
      } else if(coupon.descrizione_metodo.includes('€')) {
        coupon.num_offerta += '€';
      }
      return coupon;
    });
  }

  addProductCoupon(coupon) {
    this.campaignService.addProductCoupon(this.campaign.name, coupon.type_code, this.campaign.goalId).subscribe(
      res => res,
      err => console.error(err),
      () => {
        this.couponService.getProductCouponSuggestions(this.campaign.goalId, this.campaign.name, coupon.type_code)
        .then(res => {
          let productCoupon: any = {
            offerta_min: res[0].offerta_min,
            offerta_max: res[0].offerta_max,
            offerta_slider: this.couponService.sliderSteps(res[0].offerta_min, res[0].offerta_max, 5),
            offerta: res[0].offerta_utente,
            selectedProducts: null,
            selectedCategoriesLevel: null,
            selectedCategoriesCodes: null
          }
          if (coupon.type_code === 3) {
            if (!this.productCouponsF) {
              this.productCouponsF = [];
            }
            this.productCouponsF.push(productCoupon);
          } else {
            if (!this.productCouponsNF) {
              this.productCouponsNF = [];
            }
            this.productCouponsNF.push(productCoupon);
          }
        })
      }
    );
  }

  deleteProductCoupon(i: number, typeCode) {
    if (typeCode === 3) {
      if (this.productCouponsF.length > 0) {
        this.productCouponsF.splice(i, 1);
      }
    } else {
      if (this.productCouponsNF.length > 0) {
        this.productCouponsNF.splice(i, 1);
      }
    }
  }

  getCouponProductsF(filters, productCoupon) {
    productCoupon.selectedProducts = [];
    productCoupon.selectedCategoriesLevel = filters[0];
    productCoupon.selectedCategoriesCodes = filters[1];
  }

  getCouponProductsNF(filters, productCoupon) {
    productCoupon.selectedProducts = [];
    productCoupon.selectedCategoriesLevel = filters[0];
    productCoupon.selectedCategoriesCodes = filters[1];
  }

  /**
   * Richiama la lista di prodotti delle categorie selezionate
   * @param productCoupon
   */
  applyCouponProductsFilter(productCoupon): Promise<any> {
    return new Promise((resolve, reject) => {
      productCoupon.products = [];
      let targeted_stores: number[] = [];
      this.campaign.stores.forEach(store => targeted_stores.push(+store.code));

      let data = {
        targeted_stores: targeted_stores,
        product_level_type : productCoupon.selectedCategoriesLevel ? productCoupon.selectedCategoriesLevel : productCoupon.livello_merceologico,
        product_level_code : productCoupon.selectedCategoriesCodes ? productCoupon.selectedCategoriesCodes : [...productCoupon.lista_codici_livello.split(',')]
      }

      if (typeof data.product_level_code[0] === 'string') {
        data.product_level_code = data.product_level_code.map(code => +code);
      }

      this.campaignService.getCouponProduct(data).subscribe(
        res => productCoupon.products = [...res],
        err => console.error(err),
        () => {
          productCoupon.showProductsTable =  true;
          resolve(productCoupon);
        }
      );
    })
  }

  ngOnDestroy() {
    this.savedSelectedCategories.emit(this.categories);
    this.savedProductCouponsF.emit(this.productCouponsF);
    this.savedProductCouponsNF.emit(this.productCouponsNF);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-4/coupons/campaign-coupons.component.ts